<template>
  <div class="new-order">

    <ReportsTabs
      :tabs="tabs"
      :warning="true"
      title="Отчет по продажам"
      :class="[
        {'tab--single': tabs.length === 1},
        {'tab--some': tabs.length === 2},
        'tab--new-order',
      ]">

      <ReportsSellingZgi
        v-show="$route.query.tab === 'zgi'"
        :disabled="isDisabledEmployeeList"
      />

      <ReportsSellingCut
        v-show="$route.query.tab === 'cut'"
        :disabled="isDisabledEmployeeList"
      />

      <ReportsSellingOpt
        v-show="$route.query.tab === 'opt'"
        :disabled="isDisabledEmployeeList"
      />

    </ReportsTabs>

  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from "vuex";
import {PAGES} from "@/constants/pages";
import {NEW_ORDER_TAB} from "@/store/modules/account/variables";

export default {
  name: "ReportsSelling",

  components: {
    ReportsTabs: () => import('@/pages/account/components/ReportsTabs'),
    ReportsSellingZgi: () => import('./ReportsSellingZgi'),
    ReportsSellingCut: () => import('./ReportsSellingCut'),
    ReportsSellingOpt: () => import('./ReportsSellingOpt'),
  },

  metaInfo() {
    return {
      title: `Отчет по продажам - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  data: () => ({
    path: '',
    isDisabledEmployeeList: false,
    orderCount: {
      zgi: 0,
      cut: 0,
      opt: 0,
    },
    tabs: [
      {
        name: PAGES.report_selling_zgi.title,
        path: NEW_ORDER_TAB.zgi.path
      },
      {
        name: PAGES.report_selling_cut.title,
        path: NEW_ORDER_TAB.cut.path
      },
      {
        name: PAGES.report_selling_opt.title,
        path: NEW_ORDER_TAB.opt.path
      },
    ],
  }),

  computed: {
    ...mapState({
      configAccess: state => state.user.configAccess,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },

  methods: {
    ...mapActions('account', [
      'pullEmployees',
      'addEmptyEmployee',
    ]),

    ...mapActions('account/dealers', [
      'setDealers',
      'addEmptyDealer',
    ]),

    ...mapActions('account/orders', [
      'setStatusList',
      'addEmptyStatus',
    ]),

    orderCountUpdate(type, number) {
    },

    isReadOnlyPage() {
      const readonly = this.configAccess.reports.report_selling.main === 1;
      return readonly;
    },

    isNeedDisabled() {
      this.isDisabledEmployeeList = this.isReadOnlyPage()
      if (!this.isDisabledEmployeeList) {
        this.addEmptyEmployee()
      }
    },

    async fetchData() {
      await Promise.all([
        this.pullEmployees().then(res => {
          this.isNeedDisabled()
        }),
        this.setDealers(true).then(res => {
          this.addEmptyDealer();
        }),
        this.setStatusList().then(res => {
          this.addEmptyStatus();
        }),
      ]).then(res => {
        const query = this.$route.query.tab;
        const tabs = this.tabs.map(el => el.path);
        if (!tabs.includes(query)) {
          this.$router.push({
            query: {
              tab: this.tabs[0].path,
            }
          });
        }
      }).finally(() => {
        this.togglePreload(false);
      });
    },
  },

  created() {
    this.togglePreload();
    this.fetchData();
  },

}
</script>

<style scoped lang="scss">
.new-order {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
</style>
